import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "PopoverArrow-root_1ersp",
  "shape": "PopoverArrow-shape_TWS1p"
};
const PopoverArrow = /*#__PURE__*/React.forwardRef(PopoverArrow_withRef);
function PopoverArrow_withRef({
  className,
  ...extraProps
}, ref) {
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    "aria-hidden": true,
    className: clsx(styles.root, className),
    ...extraProps,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.shape
    })
  });
}
export { PopoverArrow };